module.exports = __webpack_public_path__ + "staticfr/media/marcas (1).228223c9.jpg";